module.exports = {"520111004":"贵筑街道","520111005":"阳光街道","520111006":"清溪街道","520111007":"溪北街道","520111008":"黄河路街道","520111009":"平桥街道","520111010":"小孟街道","520111011":"金筑街道","520111012":"党武街道","520111101":"青岩镇","520111102":"石板镇","520111104":"麦坪镇","520111105":"燕楼镇","520111201":"孟关苗族布依族乡","520111204":"湖潮苗族布依族乡","520111205":"久安乡","520111207":"高坡苗族乡","520111208":"黔陶布依族苗族乡","520111209":"马铃布依族苗族乡","520111400":"羊艾农场"}


//////////////////
// WEBPACK FOOTER
// ./src/town/520111.json
// module id = 2581
// module chunks = 0